import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin(nuxtApp => {
  const { vueApp } = nuxtApp;

  Sentry.init({
		app: [vueApp],
		release: process.env.GLOBAL_O7RELEASE,
		dsn: 'https://ce98c66a89060c7d88ce163614effb12@o446669.ingest.us.sentry.io/4511268295475200',
		environment: nuxtApp.$config.public.sentryEnvironment,
		integrations: [new Sentry.BrowserTracing()],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 0.8,
		beforeSend(event, hint) {
			// Check if it is an exception, and if so, log it.
			if (event.exception) {
				// eslint-disable-next-line no-console
				console.error(`[Exeption handled by Sentry]: (${hint.originalException})`, { event, hint });
			}
			// Continue sending to Sentry
			return event;
		}
  });

  vueApp.mixin(Sentry.createTracingMixins({ trackComponents: true, timeout: 2000, hooks: ['activate', 'mount', 'update'] }));
  Sentry.attachErrorHandler(vueApp, { logErrors: false, attachProps: true, trackComponents: true, timeout: 2000, hooks: ['activate', 'mount', 'update'] });

  return {
    provide: {
      sentrySetContext: Sentry.setContext,
      sentrySetUser: Sentry.setUser,
      sentrySetTag: Sentry.setTag,
      sentryAddBreadcrumb: Sentry.addBreadcrumb,
      sentryCaptureException: Sentry.captureException
    }
  };
});